import { MeetingRoomRequestInput } from "@lib/store";
import { useMeetingRoomRequestContext } from "@lib/logic";
import { useHereAndNow } from "../HereAndNowContext";

type MeetingRoomRequestOverrides = Partial<MeetingRoomRequestInput>;

export const useActiveMeetingRoomRequest = (overrides: MeetingRoomRequestOverrides = {}) => {
  const { buildingId, selectedFloorId, currentRoomDateTimes } = useHereAndNow();

  return useMeetingRoomRequestContext({
    buildingId: overrides.buildingId ?? buildingId,
    selectedFloorId: overrides.selectedFloorId === undefined ? selectedFloorId : overrides.selectedFloorId,
    startDateTime: overrides.startDateTime ?? currentRoomDateTimes.startDateTime,
    endDateTime: overrides.endDateTime ?? currentRoomDateTimes.endDateTime,
  });
};
